import k from '../constants/k'
import { w, h } from '../state/globals'
import { GameObj } from 'kaplay'
import { addHoverEffect } from './mouse'

k.loadSprite('arrow', 'sprites/ui/arrow.png')

const arrowPos = {
  left: k.vec2(10, h / 2),
  right: k.vec2(w - 10, h / 2)
}

export default (float: 'left' | 'right', scene: string, cursor: GameObj) => {
  const flipX = float === 'left'
  const arrow = k.add([
    k.sprite('arrow', { flipX }),
    k.anchor('center'),
    k.area(),
    k.scale(1),
    k.pos(arrowPos[float]),
    k.z(8)
  ])

  addHoverEffect(arrow, cursor)

  arrow.onClick(() => {
    k.play('pop')
    k.go(scene)
  })
}
